import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import ContentLayout from "./ContentLayout";
import { useIsFetching } from "@tanstack/react-query";

type Props = {};

const DefaultLayout = (props: Props) => {
  const { t } = useTranslation();
  const isFetching = useIsFetching();
  const sc = useRef<any>();

  useEffect(() => {
    sc.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [sc]);

  return (
    <>
      <Spin className="z-[100000]" spinning={isFetching ? true : false} size="large" tip={t("loading") || ""} delay={500}>
        <div>
          <ContentLayout />
        </div>
      </Spin>
    </>
  );
};

export default DefaultLayout;
